import React from "react";
import Grid from "@material-ui/core/Grid";
import style from "../Tables/Table.module.scss";

export const StyledDivider = (props) => {
  const { text } = props;
  return (
    text && (
      <Grid container alignItems="center" className={style.divider}>
        <Grid item xs={12}>
          {text}
        </Grid>
      </Grid>
    )
  );
};
